import { Button } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { isArray } from 'lodash';
import { useTranslation } from 'react-i18next';
import { PiTrash } from 'react-icons/pi';
import { useGetLanguages } from 'services/enums';
import { ITitle } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getLanguageSelectOptions } from 'utils/global/language.utils';
import './TitleCard.scss';

interface ITitleCardProps {
  title: ITitle;
  index: number;
  displayMode?: boolean;
  onRemove?: () => void;
  name?: string;
}

const TitleCard = ({
  title,
  index,
  displayMode,
  onRemove,
  name = 'otherTitles',
}: ITitleCardProps) => {
  const {
    values,
    status,
    setFieldValue,
  }: IFormikContextType<Record<string, ITitle[]> & { mainTitle: ITitle }> =
    useFormikContext<Record<string, ITitle[]> & { mainTitle: ITitle }>();
  const { t } = useTranslation();
  const languages = useGetLanguages();

  const titles = isArray(values[name]) ? values[name] : [];
  return (
    <div className='title-card'>
      {displayMode ? (
        <div className='title-name'>
          <div className='title-header'>
            {title.title} ({t(`enum.LANGUAGE.${title.language}`)})
          </div>
          {title.version && <div className='title-footer'>{title.version}</div>}
        </div>
      ) : (
        <div className='title-inputs'>
          <FormInput.Select
            name={`otherTitles[${index}].language`}
            label={t('input.label.language')}
            value={{
              value: titles[index].language,
              label: t(`enum.LANGUAGE.${titles[index].language}`),
            }}
            appBackground
            options={getLanguageSelectOptions(languages.data, [
              ...titles,
              values.mainTitle,
            ])}
          />
          <FormInput.Text
            name={`${name}[${index}].title`}
            label={t('input.label.title')}
            appBackground
          />
          <FormInput.Text
            name={`otherTitles[${index}].version`}
            label={t('input.label.version')}
            appBackground
          />
        </div>
      )}
      {!displayMode && (
        <Button
          isClear
          onlyIcon
          variant={BUTTON_VARIANT.remove}
          onClick={onRemove}>
          <Button.Icon icon={<PiTrash />} />
        </Button>
      )}
    </div>
  );
};

export default TitleCard;
